<div class="side-sheet" [ngClass]="{'active': selectedReservationId, 'view': viewType}">
    <div class="d-flex h-100">

        <div class="overlay" (click)="closeDetails()"></div>

        <div class="sheet-container booktable-reservationDetails">
            <div class="sheet-head">
                <div class="title">{{'reservations.Reservation Details' | translate}}</div>

                <button type="button" mat-icon-button (click)="closeDetails()">
                    <img src="./assets/images/icons/close.svg" alt="">
                </button>
            </div>
            <div *ngIf='dataLoading' class="dataLoading">
                <mat-spinner class="m-auto" diameter="50"></mat-spinner>
            </div>

            <ng-container *ngIf="!dataLoading">
                <div class="sheet-content p-0">
                    <div class="reservation-details-sheet">
                        <div class="reservation-details" *ngIf="details">
                            <div class="top-cards d-flex">
                                <div class="card">
                                    <div class="card-content">
                                        <p class="font-16 fontSemiBold">{{details.reservationDate | date : 'EE, d MMM'}}
                                        </p>
                                        <p class="font-14 fontSemiBold">{{details.reservationTimeFrom}}</p>
                                        <p class="font-12 fontSemiBold title">{{'content4.Date & Time' | translate }}</p>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <p class="font-16 fontSemiBold text-wrap pr-3 pl-3">{{details.tableName}}</p>
                                        <p class="font-12 fontSemiBold title">{{'content4.Table' | translate }}</p>
                                        <button mat-icon-button *ngIf="details.canEditTable && canEdit"
                                            (click)="details.canEditTable ? openChangeTable() : null">
                                            <mat-icon>edit</mat-icon>
                                        </button>
                                    </div>
                                </div>
                                <div class="card">
                                    <div class="card-content">
                                        <p class="font-16 fontSemiBold">{{details.partySize}}</p>
                                        <p class="font-12 fontSemiBold title">{{'reservations.Party Size' | translate }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div class="restaurant-details">
                                <div class="name-with-image">
                                    <div class="image-circle no-border">
                                        <!-- <span class="font-14 fontMedium"> Karam Beirut - Riyadh North </span> -->
                                        <!-- <img *ngIf="item.icon" [src]="item.icon"
                                            (error)="item.icon = ''"> -->
                                        <img [src]="details.restaurantIcon" alt="">
                                    </div>
                                    <div class="name">
                                        <h5 class="font-14 fontMedium">{{details.restaurantNameEN}}</h5>
                                        <h5 class="font-14 font-weight-bold">{{details.restaurantNameAR}}</h5>
                                    </div>
                                </div>
                            </div>
                            <div class="inner-details">
                                <div class="lists">
                                    <div class="list-item d-flex">
                                        <img src="/assets/images/icons/special-request-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'content.Type' |
                                            translate}}</span>
                                        <span class="ml-auto font-14 fontMedium list-item-details">
                                            <span
                                                *ngIf="details.reservationType == 'Scheduled'">{{"reservations.Scheduled" | translate}}</span>
                                            <span *ngIf="details.reservationType == 'WalkIn'">{{"reservations.WalkIn" | translate}}</span>
                                            <span
                                                *ngIf="details.reservationType == 'WaitingList'">{{"reservations.WaitingList" | translate}}</span>
                                            <span *ngIf="details.reservationType == 'ReservedNow'">
                                              {{"reservations.By Customer" | translate}}
                                              <span class="font-10">({{"reservations.Table QR Code" | translate}})</span>
                                            </span>
                                            <span *ngIf="details.reservationType == 'Event'">{{"reservations.Event" | translate}}</span>
                                            <ng-container *ngIf="details.isDeletedEvent">
                                                <span class="ml-1"> ({{'reservations.previousEvent' | translate }})</span>
                                            </ng-container>
                                            <ng-container *ngIf="details.eventName">
                                                <span> - {{details.eventName}} </span>
                                            </ng-container>
                                        </span>
                                    </div>
                                    <div class="list-item d-flex">
                                        <img src="/assets/images/icons/reservation-number-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'content4.Reservation No' |
                                            translate}}</span>
                                        <span class="ml-auto font-14 fontMedium list-item-details">
                                            {{details.reservationNumber}}
                                        </span>
                                    </div>
                                    <div class="list-item d-flex" *ngIf="details.reservationChannel.name">
                                        <img src="/assets/images/icons/channel-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'reservations.Reservation Channel' | translate }}</span>
                                        <span
                                            class="ml-auto font-14 fontMedium list-item-details">{{details.reservationChannel.name}}</span>
                                    </div>
                                    <div class="list-item d-flex" *ngIf="details.reservationDuration">
                                        <img src="/assets/images/icons/duration-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'reservations.Duration' | translate }}</span>
                                        <button class="btn-bordered" type="button"
                                            *ngIf="timeDuration.value != details.reservationDuration && canEdit"
                                            (click)="updateExtendedDuration()"
                                            [class.loading]="updateLoading"
                                            [disabled]="updateLoading">
                                            {{"forms.Update" | translate}}
                                        </button>
                                        <div class="counter-calc ml-auto">
                                            <div class="calc-area">
                                                <button mat-icon-button type="button" (click)="editDuration('-')"
                                                    [disabled]="timeDuration.value == details.reservationDuration"
                                                    *ngIf="details.canExtendDuration && canEdit">
                                                    <mat-icon>remove_circle_outline</mat-icon>
                                                </button>
                                                <div class="m-0 font-14">{{timeDuration.duration}}</div>
                                                <button mat-icon-button type="button" (click)="editDuration('+')"
                                                *ngIf="details.canExtendDuration && canEdit">
                                                    <mat-icon>add_circle_outline</mat-icon>
                                                </button>
                                            </div>
                                        </div>


                                        <!-- <div class="counter-calc" *ngIf="details.reservationDuration">
                                            <div class="counter-label font-14 fontRegular list-item-title">
                                                {{'reservations.Duration' | translate}}
                                            </div>
                                            <div class="calc-area ml-auto">
                                                <button mat-icon-button type="button" (click)="editDuration('-')">
                                                    <mat-icon>remove_circle_outline</mat-icon>
                                                </button>
                                                <div>{{details.reservationDuration}}</div>
                                                <button mat-icon-button type="button" (click)="editDuration('+')">
                                                    <mat-icon>add_circle_outline</mat-icon>
                                                </button>
                                            </div>
                                        </div> -->
                                    </div>
                                    <div class="list-item d-flex" *ngIf="details.reservationPrefrences">
                                        <img src="/assets/images/icons/outdoor-seat-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'content4.Seat preferences' |
                                            translate }}</span>
                                        <span
                                            class="ml-auto font-14 fontMedium list-item-details">{{details.reservationPrefrences}}</span>
                                    </div>
                                    <div class="list-item d-flex" *ngIf="details.specialRequest">
                                        <img src="/assets/images/icons/special-request-ic.svg" alt="">
                                        <span class="font-14 fontRegular list-item-title">{{'reservations.Special Request' |
                                            translate }}</span>
                                        <span
                                            class="ml-auto font-14 fontMedium text-end list-item-details special">{{details.specialRequest}}</span>
                                    </div>
                                </div>

                                <div class="server pt-2">
                                    <div class="d-flex align-items-center">
                                        <ng-container *ngIf="details.waitersList?.length">
                                            <div>
                                                <div class="name-with-image"
                                                    *ngFor="let item of details.waitersList; index as i"
                                                    [class.mt-3]="i > 0">
                                                    <div class="image-circle">
                                                        <span class="font-14 fontMedium" *ngIf="!item.profilePic">
                                                            {{item.name | shortName }} </span>
                                                        <img *ngIf="item.profilePic" [src]="item.profilePic"
                                                            (error)="item.profilePic = ''">
                                                    </div>
                                                    <div class="name">
                                                        <h5 class="font-12 fontRegular grey-color">
                                                            {{'reservations.Assigned server' | translate }}</h5>
                                                        <div class="font-16 fontMedium">{{item.name}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </ng-container>
                                        <div *ngIf="!details.waitersList?.length">
                                            {{ 'servers.No server assigned.' | translate }}
                                        </div>
                                        <div class="ml-auto" *ngIf="details.canEditWaiter && canEdit">
                                            <button mat-icon-button
                                                (click)="openAssignServer()"><mat-icon>edit</mat-icon></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="user-details" *ngIf="details.customer">
                                <div class="name-with-image">
                                    <div class="image-circle">
                                        <span class="font-14 fontMedium" *ngIf="!details.customer.icon"> {{details.customer.fName + '' +
                                            details.customer.lName | shortName}} </span>
                                        <img *ngIf="details.customer.icon" [src]="details.customer.icon"
                                            (error)="details.customer.icon = ''">
                                        <!-- <img src="/assets/images/restaurant-img.png" alt=""> -->
                                    </div>
                                    <div class="name">
                                        <h5 class="font-16 fontMedium">{{details.customer.fName}}
                                            {{details.customer.lName}}
                                        </h5>

                                        <span class="font-14 fontRegular grey-color"
                                            *ngFor="let tag of details.customer.tagsList; let i = last">{{tag.name}}<span
                                                *ngIf="!i" class="ml-0">, </span></span>
                                    </div>
                                </div>
                                <div class="item d-flex">
                                    <span class="font-14 fontRegular grey-color">{{'forms.Phone number' | translate }}</span>
                                    <span class="font-14 fontMedium ml-auto phoneNumber">
                                      {{details.customer.phoneCode}} {{details.customer.phoneNumber}}
                                    </span>
                                </div>
                                <div class="item d-flex">
                                    <span class="font-14 fontRegular grey-color">{{'forms.Email' | translate }}</span>
                                    <span class="font-14 fontMedium ml-auto">{{details.customer.email || '-'}}</span>
                                </div>
                                <div class="item d-flex orange-color" *ngIf="details.customer.customerPoints!.totalPoint">
                                    <span class="font-14 fontRegular">{{'Redeeming.loyalty points' | translate }}</span>
                                    <span class="font-14 fontMedium ml-auto">{{details.customer.customerPoints!.totalPoint}}</span>
                                </div>
                            </div>

                            <ng-container *ngIf="details.orderDetails">
                                <div class="order-list-btns">
                                    <p class="font-12 fontRegular grey-color">
                                      {{'orders.placed on this reservation' | translate: {no: details.orderDetails.length} }}
                                    </p>
                                    <div class="list-btns">
                                      <button matRipple class="order-btn"
                                        *ngFor="let order of details.orderDetails" (click)="changeActiveOrder(order)"
                                        [class.active]="activeOrder.orderId == order.orderId">
                                        {{'placeOrder.Order' | translate }} # {{order.orderNumber}}
                                      </button>
                                    </div>
                                </div>
                                <div class="heads mt-0">
                                    <p class="font-16 fontMedium">{{'orders.Order Details' | translate}}</p>
                                </div>

                                <div class="order-items" *ngFor="let item of activeOrder?.orderItems; let itemIndex = index">
                                    <div class="Order-details">
                                      <div class="item-lists">
                                        <div class="list-item my-0"  [ngClass]="{ 'overlayed': item.status == 'Cooking' }">
                                          <div class="d-flex">
                                            <div class="img-card">
                                              <img [src]="item.itemPic" alt="">
                                              <div class="overlay-img" *ngIf="(item.status == 'Cooking' || item.status == 'Preparing') && item.preparingTimer">
                                                <p class="font-12 fontSemiBold text-center">
                                                  <ng-container *ngIf="item.preparingTimer.isNegative">-</ng-container>
                                                  <span *ngIf="item.preparingTimer.m != 0">
                                                    {{item.preparingTimer.m}} {{'placeOrder.mins' | translate}}</span>
                                                  <span *ngIf="item.preparingTimer.m == 0">
                                                    {{item.preparingTimer.s}} {{'orders.secs' | translate}}</span>
                                                </p>
                                              </div>
                                            </div>
                                            <span class="font-14 fontRegular grey-color ml-2">x{{item.quantity}}</span>
                                            <div class="list-details ml-3 flex-grow-1">
                                              <p class="title font-16 fontMedium">{{item.itemName}}</p>
                                              <p class="font-14 fontRegular grey-color">{{'placeOrder.Size:' | translate }}
                                                <span class="font-14 fontRegular text-color">
                                                  <ng-container *ngIf="!item.sizeName">
                                                    {{item.itemSizes?.size || item.itemSizes?.name}}
                                                  </ng-container>
                                                  <ng-container *ngIf="item.sizeName">
                                                    {{item.sizeName}}
                                                  </ng-container>
                                                </span>
                                              </p>
                                              <div class="ingredient-bg mt-2" *ngIf="item.additions?.length">
                                                <div class="font-12 fontRegular grey-color mb-3" *ngFor="let extra of item.additions">
                                                  <p>{{extra.name}}:</p>
                                                  <p class="font-12 fontMedium green-color" *ngFor="let item of extra.itemAdditionlist">
                                                    <span *ngIf="item.isSelected">{{item.name}}</span>
                                                  </p>
                                                </div>
                                              </div>
                                              <div class="ingredient-bg mt-2" *ngIf="item.variants?.length">
                                                <div class="font-12 fontRegular grey-color mb-3" *ngFor="let extra of item.variants">
                                                  <p>{{extra.name}}:</p>
                                                  <p class="font-12 fontMedium green-color" *ngFor="let item of extra.itemVariantlist">
                                                    <span *ngIf="item.isSelected">{{item.name}}</span>
                                                  </p>
                                                </div>

                                              </div>
                                              <div class="ingredient-bg pt-0" *ngIf="item.unWantedOptionalIngredients?.length">
                                                <p class="font-12 fontRegular grey-color mb-1">
                                                  {{'placeOrder.Unwanted Ingredients' | translate }}</p>
                                                <p class="highlited font-14 fontRegular"
                                                  *ngFor="let ingredient of item.unWantedOptionalIngredients">
                                                  {{ingredient.name}}</p>
                                              </div>
                                              <div class="ingredient-bg mt-2" *ngIf="item.specialRequest">
                                                <p class="font-12 fontRegular orange-color mb-1">{{'placeOrder.Special request' | translate }}
                                                </p>
                                                <p class="font-12 fontRegular text-color">{{item.specialRequest}}</p>
                                              </div>
                                              <div class="mt-2" *ngIf="item.statusPermissions?.canServed && canEdit">
                                                <button matRipple class="status-btn"
                                                (click)="changeItemStatus(item.id)">
                                                  {{'placeOrder.Confirm Serving' | translate }}
                                                </button>
                                              </div>
                                            </div>

                                            <div>
                                              <div class="red-color font-14 ml-auto" *ngIf="item.paidQuantity">
                                                  {{'orders.Paid' | translate}} X{{item.paidQuantity}}
                                              </div>
                                              <div class="green-color font-14 ml-auto"
                                                *ngIf="item.freeQuantity && activeOrder.paymentDetails.length">
                                                ( {{'placeOrder.Free' | translate}} X{{item.freeQuantity}} )
                                              </div>
                                            </div>
                                          </div>

                                          <div class="status mt-3">
                                            <div class="d-flex align-items-center justify-content-center">
                                              <!-- <div class="mr-auto">
                                                <span class="font-16 fontLight mr-2">{{item.curruncyName}}</span>
                                                <span class="font-16 fontSemiBold">{{item.totalItemprice}}</span>
                                              </div> -->

                                              <span class="font-15 fontRegular ml-auto"
                                                *ngIf="!activeOrder?.editMode && item.status"
                                                [ngClass]="{
                                                  'cooking-status': item.status == 'Cooking',
                                                  'preparing-status': item.status == 'Preparing',
                                                  'waiting-status': item.status == 'New',
                                                  'ready-status': item.status == 'Ready' || item.status == 'Served'
                                                }">
                                                <span class="dot mr-1"></span>

                                                <ng-container *ngIf="item.status == 'New' || item.status == 'Ongoing'">
                                                  {{'placeOrder.Waiting' | translate}}
                                                </ng-container>
                                                <ng-container *ngIf="item.status == 'Cooking'">
                                                  {{'orders.Cooking' | translate}}
                                                </ng-container>
                                                <ng-container *ngIf="item.status == 'Preparing'">
                                                  {{'orders.Preparing' | translate}}
                                                </ng-container>
                                                <ng-container *ngIf="item.status == 'Ready'">
                                                  {{'orders.Ready' | translate}}
                                                </ng-container>
                                                <ng-container *ngIf="item.status == 'Done'">
                                                  {{'orders.Ready' | translate}}
                                                </ng-container>
                                                <ng-container *ngIf="item.status == 'Served'">
                                                  {{'placeOrder.Served' | translate}}
                                                </ng-container>
                                              </span>
                                            </div>
                                          </div>

                                        </div>
                                      </div>
                                    </div>
                                </div>
                                <div class="order-field" *ngIf="activeOrder.orderNotes">
                                  <h3 class="font-20 fontMedium title d-flex align-items-center">
                                    <img src="./assets/images/icons/special-request-orange.svg" alt="">
                                    {{'reservations.Special Request' | translate }}
                                  </h3>
                                  <p>{{activeOrder.orderNotes}}</p>
                                </div>
                                <div class="heads pt-1 pb-1 mt-0"></div>
                                <app-prices-details *ngIf="activeOrder" [orderDetails]="activeOrder"></app-prices-details>
                                <div class="checkout">
                                    <app-paid-list [orderDetails]="activeOrder"></app-paid-list>
                                </div>
                            </ng-container>

                        </div>

                    </div>
                </div>
                <div class="sheet-actions" *ngIf="canEdit && details && checkAvailabilityOfButtons()">
                    <!-- Details -->

                    <div class=" booktable-reservationDetails">
                        <!-- is Host -->
                        <div class="d-flex align-items-center">
                            <div class="big" *ngIf="!details.canPlaceOrder && checkAvailabilityOfButtons()">
                                <button mat-button color="primary" class="w-100" *ngIf="details.canArrived && canEdit"
                                    (click)="changeStatus('Arrived')" [disabled]="btnLoading"
                                    [class.loading]="loadingType == 'Arrived'">
                                    {{'content4.Confirm Arriving' | translate }}
                                </button>
                                <button mat-button color="primary" class="w-100" *ngIf="details.canSeated && canEdit"
                                    (click)="changeStatus('Seated')" [disabled]="btnLoading"
                                    [class.loading]="loadingType == 'Seated'">
                                    {{'content4.Seat' | translate }}
                                </button>
                                <button mat-button color="primary" class="w-100" *ngIf="details.canReleased && canEdit"
                                    (click)="changeStatus('Released')" [disabled]="btnLoading"
                                    [class.loading]="loadingType == 'Released'">
                                    {{'content4.Release Table' | translate }}
                                </button>
                            </div>
                            <div class="small" *ngIf="details.canEdit || details.canCancelled || details.canNoShow">
                                <button mat-icon-button type="button" class="btn-grey-E" [matMenuTriggerFor]="menu"
                                    [disabled]="btnLoading"
                                    [class.loading]="loadingType == 'Cancelled' || loadingType == 'NoShow'">
                                    <mat-icon class="text-color">more_horiz</mat-icon>
                                </button>
                                <mat-menu #menu="matMenu" class="reservation-mat-menu">
                                    <a mat-menu-item *ngIf="details.canEdit && canEdit"
                                        [routerLink]="['/admin/reservations/'+viewType+'/edit', restaurantId, selectedReservationId]">
                                        <span class="font-14 fontRegular">{{'general.Edit' | translate }}</span>
                                    </a>
                                    <button mat-menu-item *ngIf="details.canCancelled && canEdit"
                                        (click)="changeStatus('Cancelled')" [disabled]="btnLoading"
                                        [class.loading]="loadingType == 'Cancelled'">
                                        <span class="font-14 fontRegular red-color">{{'forms.Cancel' | translate }}</span>
                                    </button>
                                    <button mat-menu-item *ngIf="details.canNoShow && canEdit" (click)="changeStatus('NoShow')"
                                        [disabled]="btnLoading" [class.loading]="loadingType == 'NoShow'">
                                        <span class="font-14 fontRegular red-color">{{'guests.No Show' | translate
                                            }}</span>
                                    </button>
                                </mat-menu>

                            </div>
                        </div>
                        <!-- is Server -->
                        <div class="d-flex align-items-center mt-2 justify-content-sm-between"
                            *ngIf="details.canPlaceOrder || details.canReleased">
                            <div class="small with-text w-100 mr-1">
                                <a mat-button class="w-100 ml-0" color="primary" *ngIf="details.canPlaceOrder && canEdit"
                                    [routerLink]='["/admin/reservations/" + viewType + "/place-order/", restaurantId, selectedReservationId]'>
                                    {{'reservations.Manage Order' | translate }}
                                </a>
                            </div>
                            <div class="small with-text w-100 ml-1">
                                <button mat-button class="w-100 btn-grey-E ml-auto" *ngIf="details.canReleased && canEdit"
                                    (click)="changeStatus('Released')" [disabled]="btnLoading"
                                    [class.loading]="loadingType == 'Released'">
                                    {{'content4.Release Table' | translate }}
                                </button>
                                <!-- <a mat-button class="w-100 btn-grey-E ml-auto">
                                    {{'content4.Release Table' | translate }}
                                </a> -->
                            </div>
                        </div>
                    </div>
                </div>
            </ng-container>
        </div>
    </div>
</div>
